import { DeliveryMethodEnum, GRReportNameEnum } from '@shared/enums';
import { GRAuth0Role } from '../../auth0/auth0.models';
import { GREnvironment } from '../grassroots/grassroots.models';
import * as yup from 'yup';

export const createTenantValidationSchema = yup.object({
  displayName: yup
    .string()
    .required()
    .matches(/^[^0-9]*$/, 'displayName must not contain numbers'),
  environment: yup.mixed<GREnvironment>().oneOf(Object.values(GREnvironment)).required(),
  users: yup
    .array()
    .of(
      yup.object({
        email: yup.string().email().required(),
        role: yup.mixed<GRAuth0Role>().oneOf(Object.values(GRAuth0Role)).required(),
      })
    )
    .min(1)
    .required(),
  clickerGroupName: yup.string(),
  useS3ForReports: yup.boolean(),
  reports: yup
    .array()
    .of(
      yup.object({
        reportName: yup.mixed<GRReportNameEnum>().oneOf(Object.values(GRReportNameEnum)).required(),
        deliveryMethod: yup.mixed<DeliveryMethodEnum>().oneOf(Object.values(DeliveryMethodEnum)).notRequired(),
        reportsTo: yup.string().notRequired(),
        emailSubject: yup.string().notRequired(),
        emailBody: yup.string().notRequired(),
        repliesFrom: yup.string().notRequired(),
      })
    )
    .defined(),
});
